import axios from "axios";

const instance = axios.create({
  baseURL: "https://doc-api.pkapil.com/",
  timeout: 10000,
});

export default instance;
